import { render, staticRenderFns } from "./Reportview_promotion.vue?vue&type=template&id=ba1d0ece&"
import script from "./Reportview_promotion.vue?vue&type=script&lang=js&"
export * from "./Reportview_promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports